export const avatarsEndpointPath = '/api/v2/avatars'
export const avatarsSelectedEndpointPath = '/api/v2/avatars/selected'
export const profileEndpointPath = '/api/v1/profile'
export const authenticationExternalEndpointPath = '/api/v2/authentication/external'
export const protectRewardsRedemptionEndpointPath = '/api/v1/profile/redemptions/tfa'
